// +----------------------------------------------------------------------
// | 分享页 /decision/share/:token（免登录，只看用户主动分享的公开内容）
// +----------------------------------------------------------------------
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getSharedDecision } from '../../api/decision';
import { categoryLabel } from '../../lib/categoryMap';
import './DecisionShare.less';

export default function DecisionShare() {
  const { token } = useParams();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const result = await getSharedDecision(token);
        if (mounted) setData(result);
      } catch (e) {
        if (mounted) setError(e.message || '这个分享打不开了');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [token]);

  if (loading) {
    return <div className="share center muted">正在打开…</div>;
  }

  if (error || !data) {
    return (
      <div className="share">
        <div className="share-card center">
          <p>{error || '这个分享不存在或已取消'}</p>
          <Link to="/" className="btn btn-primary btn-sm share-cta-btn">
            去「想想」
          </Link>
        </div>
      </div>
    );
  }

  const options = data.options || [];

  return (
    <div className="share">
      <div className="share-card fade-in-up">
        <div className="share-badge">🤔 有个人今天在纠结</div>

        <h1 className="share-question">{data.question || data.title}</h1>

        {data.category && <span className="tag">{categoryLabel(data.category)}</span>}

        {data.core_conflict && (
          <div className="share-block">
            <div className="share-block-title">AI 发现</div>
            <p>{data.core_conflict}</p>
          </div>
        )}

        {options.length > 0 && (
          <div className="share-block">
            <div className="share-block-title">纠结的选项</div>
            <ul className="share-options">
              {options.map((option, index) => (
                <li key={option.id || option.name}>
                  <span className="share-option-index">{String.fromCharCode(65 + index)}</span>
                  {option.name}
                </li>
              ))}
            </ul>
          </div>
        )}

        {data.selected_option && (
          <div className="share-block share-chosen">
            <div className="share-block-title">最后选了</div>
            <p className="share-chosen-name">{data.selected_option.name}</p>
          </div>
        )}

        {data.ai_summary && (
          <div className="share-block">
            <div className="share-block-title">AI 的分析</div>
            <p>{data.ai_summary}</p>
          </div>
        )}

        <div className="share-footer">
          <p>想知道 AI 最后会怎么分析？</p>
          <Link to="/" className="btn btn-primary btn-block share-cta-btn">
            进入「想想」 · 有啥纠结的，扔过来
          </Link>
        </div>
      </div>
    </div>
  );
}
